import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {IBigWinLevel, HTHWinConfig} from "../configs/HTHWinConfig";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHSound} from "../sound/HTHSound";

export class HTHBigWinPresentation implements SimplePresentation {
    private readonly FADE_AWAY_DURATION: number = 1.5;
    private _bigWinLevels: IBigWinLevel[];

    constructor() {
    }

    shouldRun(): boolean {

        return HTH.model.isBigWin && !HTH.model.brokeTheBank && HTHHelper.checkForExtraSpin(HTH.model.data.spinWin);
    }

    start(controller: SimplePresentationRunnerController): void {
        let winAmount: number = HTH.model.brokeTheBank ? HTH.model.gameData.win : HTH.model.isFreespin ? HTH.model.spinWin : HTH.model.accumulatedRoundWin;

        if (HTHGameConfig.isBigWinLevel5Played) {
            winAmount = Math.max(winAmount, HTHGameConfig.lastBigWinPlayedAmount) - Math.min(winAmount, HTHGameConfig.lastBigWinPlayedAmount);
        }
        const levels: IBigWinLevel[] = this._bigWinLevels = HTHWinConfig.getBigWinLevels(winAmount / HTH.model.gameData.playedBetValue),
            maxLevel: number = levels.length;
        HTH.bigWinView.maxLevel = maxLevel;

        // if (HTH.model.brokeTheBank) {
        //     HTHGameConfig.bigWinLevelPlayed = [false, false, false, false, false];
        //     HTHGameConfig.isBigWinLevel5Played = false;
        // }

        const newLevels: IBigWinLevel[] = JSON.parse(JSON.stringify(levels));
        for (let i = 0; i < HTHGameConfig.bigWinLevelPlayed.length; i++) {
            if (HTHGameConfig.bigWinLevelPlayed[i]) {
                newLevels.shift();
            }
        }

        for (let i = 0; i < maxLevel; i++) {
            HTHGameConfig.bigWinLevelPlayed[i] = true;
        }

        const totalWin: number = HTH.model.isFreespin ? HTH.model.spinWin : HTH.model.accumulatedRoundWin;
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            HTHSound.playTrack(HTHSound.BIGWIN_INTRO);
            HTHSound.fadeMusic(0, 0.01);
        })
        tl.add(HTH.gameViewContainer.shakeEffect(0.5, 150, true, 15), 0);
        tl.add(HTH.gameViewContainer.addOverlay(0.2, 0.7), 0.3);


        tl.add(HTH.bigWinView.show(0.1), 0.5);
        for (let index: number = 0; index < newLevels.length; index++) {
            const bigWinLevel: IBigWinLevel = newLevels[index],
                from: number = HTHGameConfig.isBigWinLevel5Played ? HTHGameConfig.lastBigWinPlayedAmount : (index === 0) ? 0 : bigWinLevel.from * HTH.model.gameData.playedBetValue,
                to: number = ((bigWinLevel.id) === maxLevel) ? totalWin : bigWinLevel.to * HTH.model.gameData.playedBetValue,
                levelStartTime = tl.duration();
            tl.add(() => {
                controller.setSkipCallback(() => {
                    HTH.bigWinView.onAbort(bigWinLevel.id - 1);
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            }, levelStartTime);
            tl.add(HTH.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id, index, newLevels.length), levelStartTime);
            tl.addLabel(bigWinLevel.type + "_end");
        }

        if (maxLevel === 5) {
            HTHGameConfig.isBigWinLevel5Played = true;
        }
        HTHGameConfig.lastBigWinPlayedAmount = totalWin;
        tl.add(() => {
            HTHSound.playTrack(HTHSound.BIGWIN_END);
            HTHSound.fadeMusic(1, 1500);
            HTH.bigWinView.hide(this.FADE_AWAY_DURATION);
        });
        tl.add(() => {
            if (!HTH.model.brokeTheBank) {
                HTH.keypadPlugin.setWin(HTH.model.gameData.accumulatedRoundWin, true, HTHHelper.isWinBelowStake());
            }
            controller.finish()
        }, `+=${this.FADE_AWAY_DURATION * 0.8}`);

    }
}
